import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=50697f2d&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"
import style0 from "./Apps.vue?vue&type=style&index=0&id=50697f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50697f2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50697f2d')) {
      api.createRecord('50697f2d', component.options)
    } else {
      api.reload('50697f2d', component.options)
    }
    module.hot.accept("./Apps.vue?vue&type=template&id=50697f2d&scoped=true&", function () {
      api.rerender('50697f2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Apps.vue"
export default component.exports